export let tableHeader = [{
		text: "Výrobná operácia ID",
		value: "id",
		align: "left"
	},
	{
		text: "Výrobný príkaz ID",
		value: "manufacturingCommandId",
		align: "left"
	},
	{
		text: "Skladová karta",
		value: "storageCard",
		align: "left"
	},
	{
		text: "Hodnota",
		value: "value",
		align: "left"
	},
	{
		text: "Merná jednotka",
		value: "unitOfMeasure",
		align: "left"
	},
	{
		text: "",
		width: "230",
		value: "action",
		align: "right",
		sortable: false
	}
]